import { useState, useEffect } from 'react'
import { CATEGORIES } from '../utils/enums'

export const useTabManagement = (initialTab = null) => {
  const [activeTab, setActiveTab] = useState(initialTab || CATEGORIES.TEMPLATES)
  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    if (initialTab) {
      setActiveTab(initialTab)
    }
  }, [initialTab])

  return {
    activeTab,
    setActiveTab,
    searchTerm,
    setSearchTerm
  }
}
